import { useQuery } from "@tanstack/react-query";

function safeParseBody(res) {
  if (res?.body && typeof res.body === "string") {
    try {
      return JSON.parse(res.body);
    } catch {
      return res;
    }
  }
  return res;
}

function extractAgentsArray(payload) {
  if (!payload) return [];

  if (Array.isArray(payload)) return payload;

  if (Array.isArray(payload.content)) return payload.content;
  if (Array.isArray(payload.items)) return payload.items;

  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.data?.content)) return payload.data.content;
  if (Array.isArray(payload.data?.items)) return payload.data.items;

  return [];
}

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {boolean} [deps.enabled]
 */
export function useGetAgents({ callApiWithWorker, enabled = true }) {
  return useQuery({
    queryKey: ["agents"],
    enabled: Boolean(enabled),
    queryFn: async () => {
      const res = await callApiWithWorker(`/agent`, { method: "GET" });
      const payload = safeParseBody(res);
      return {
        raw: payload,
        agents: extractAgentsArray(payload),
      };
    },
    staleTime: 30_000,
  });
}
